<div #mapContainer class="maps position-relative {{styleClass}}">
  <i *ngIf="showCenter" class="icosun-auto_local position-absolute maps_button-center" (click)="onClickCenterMap()"></i>
  <div *ngIf="showPosition" class="position-absolute maps_button-position" (click)="onClickUseCurrentPosition()">
    <i class="icosun-my_location mr-1"></i>
    <span>{{'SI_USE_POSITION' | translate}}</span>
  </div>
  <google-map [options]="options" [center]="center" [width]="mapWidth" [height]="mapHeight">
    <map-marker [position]="markerPosition"
                [label]="markerLabel"
                [title]="markerTitle"
                [options]="markerOptions"
    ></map-marker>
  </google-map>
</div>
